import * as reducers from './reducers';

export const constants = {
  NAME: 'imageManager',
};

export default { constants, reducers };
